module.exports = __webpack_public_path__ + "static/media/steph.ffe5ba88.jpg";